import React from 'react';
import type { FC, ReactNode } from 'react';
import './index.less';
import { FormattedMessage, useIntl } from 'react-intl';

interface IProps {
  children?: ReactNode;
  text?: string;
}
const Agreement: FC<IProps> = ({ text }) => {
  const intl = useIntl();

  return (
    <div className="agreement">
      {`${intl.formatMessage({
        id: 'agree:click'
      })}${text}${intl.formatMessage({
        id: 'agree:text1'
      })}`}
      <a href="https://www.xback.io/terms-of-use/">
        <FormattedMessage id="agree:terms" />
      </a>
      {intl.formatMessage({
        id: 'agree:text2'
      })}
      <a href="https://www.xback.io/privacy-policy/">
        <FormattedMessage id="agree:privacy" />
      </a>
    </div>
  );
};

export default Agreement;
